import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class LanguageResolver  {
  constructor(private readonly translateService: TranslateService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.translateService.use(this.translateService.getCurrentLang());
  }
}
